import React from 'react';
import './Chatbot.less';
import DeloitteChatIcon from '../../../../../ui/DeloitteChatIcon';

interface IChatbotProp {
  onClick: () => void;
}

const Chatbot = ({ onClick }: IChatbotProp) => {
  return (
    <div className="container">
      <div className="chatbox">
        <div className="chatbox__button">
          <button className="button" onClick={onClick}>
            <DeloitteChatIcon size={80} className="chatbot-icon-animated" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
